var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultiPlatformVacuity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26_110)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.695 109.609H75.921C75.921 108.824 75.921 108.145 75.921 107.462C75.921 99.963 75.9488 92.4646 75.9117 84.9707C75.8746 78.3648 71.7575 73.1163 65.7535 72.3539C62.7908 71.9774 59.7494 72.2005 56.7404 72.1633C55.6601 72.1494 54.5752 72.1633 53.1333 72.1633C53.2909 68.6674 53.124 65.3296 53.6758 62.1173C54.348 58.1844 57.9597 55.3998 61.9377 55.0651C62.5126 55.0186 63.0922 55.0046 63.6717 55.0046C92.5933 55.0046 121.51 55 150.432 55.0046C155.713 55.0046 159.366 57.6451 160.516 62.2846C160.697 63.0098 160.771 63.7769 160.771 64.5253C160.789 74.232 160.785 83.9387 160.785 93.6407C160.785 93.9801 160.734 94.3194 160.687 94.8866C158.708 94.8866 156.76 94.8773 154.813 94.8866C149.959 94.9145 146.802 98.0292 146.704 102.934C146.658 105.128 146.695 107.327 146.695 109.605V109.609Z",
    fill: "url(#paint0_linear_26_110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.0001 111.78C25.0001 102.892 24.9954 94.0034 25.0001 85.1195C25.0001 80.3917 27.5733 77.7559 32.2606 77.7466C42.5487 77.7233 52.8414 77.7233 63.1295 77.7466C67.7009 77.7559 70.3436 80.401 70.3483 85.008C70.3714 102.901 70.3668 120.79 70.3483 138.683C70.3436 143.294 67.7055 145.968 63.148 145.981C52.7997 146.009 42.4513 146.009 32.103 145.981C27.6428 145.968 25.0001 143.267 24.9954 138.794C24.9815 129.79 24.9954 120.785 24.9954 111.785L25.0001 111.78ZM47.7368 134.662C47.7368 134.662 47.7368 134.657 47.7368 134.652C46.8698 134.652 46.0028 134.652 45.1358 134.652C45.0199 134.652 44.9039 134.652 44.788 134.662C43.2395 134.796 42.136 135.87 42.0665 137.307C42.0016 138.697 43.0772 140.082 44.5562 140.17C46.6287 140.291 48.7243 140.291 50.7968 140.161C52.3268 140.068 53.2865 138.776 53.2216 137.284C53.1567 135.81 52.1042 134.764 50.5139 134.671C49.5913 134.615 48.664 134.662 47.7414 134.662H47.7368Z",
    fill: "url(#paint1_linear_26_110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.328 134.518C152.301 133.89 152.25 133.323 152.25 132.756C152.245 123.114 152.245 113.468 152.25 103.826C152.25 100.972 152.755 100.474 155.574 100.47C161.124 100.47 166.673 100.461 172.223 100.474C174.147 100.479 174.94 101.2 174.94 103.031C174.954 113.37 174.94 123.714 174.931 134.053C174.931 134.164 174.884 134.276 174.824 134.518H152.319H152.328Z",
    fill: "url(#paint2_linear_26_110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.73 128.837C120.458 132.244 121.2 135.522 121.844 138.818C122.067 139.957 122.456 140.51 123.745 140.44C125.938 140.324 128.14 140.38 130.333 140.421C132.397 140.463 133.63 141.547 133.635 143.206C133.635 144.87 132.392 145.977 130.343 145.977C114.788 145.991 99.2328 145.995 83.6825 145.977C81.6518 145.977 80.5483 144.987 80.4927 143.313C80.437 141.565 81.5729 140.477 83.6547 140.426C85.9079 140.37 88.1658 140.338 90.4191 140.44C91.6153 140.496 92.0187 140.008 92.2273 138.929C92.8022 135.968 93.4142 133.011 94.1282 130.083C94.2487 129.594 94.9442 128.893 95.3754 128.888C103.41 128.818 111.44 128.837 119.73 128.837Z",
    fill: "url(#paint3_linear_26_110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.537 123.175H76.0693V115.453H146.537V123.175Z",
    fill: "url(#paint4_linear_26_110)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.796 140.319C174.88 140.528 174.912 140.58 174.917 140.631C175.223 145.712 174.968 145.991 169.965 145.991C165.171 145.991 160.372 145.995 155.578 145.991C152.764 145.986 152.263 145.465 152.25 142.62C152.25 141.886 152.25 141.147 152.25 140.324H174.796V140.319Z",
    fill: "url(#paint5_linear_26_110)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_26_110",
    x1: 106.959,
    y1: 55.0026,
    x2: 106.959,
    y2: 109.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_26_110",
    x1: 47.6766,
    y1: 77.7291,
    x2: 47.6766,
    y2: 146.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_26_110",
    x1: 163.596,
    y1: 100.467,
    x2: 163.596,
    y2: 134.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_26_110",
    x1: 107.063,
    y1: 128.834,
    x2: 107.063,
    y2: 145.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_26_110",
    x1: 111.303,
    y1: 115.453,
    x2: 111.303,
    y2: 123.175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_26_110",
    x1: 163.627,
    y1: 140.319,
    x2: 163.627,
    y2: 145.993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26_110"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 91,
    fill: "white",
    transform: "translate(25 55)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiPlatformVacuity);
export default __webpack_public_path__ + "static/media/Multi-Platform_Vacuity.2e18eb57f9c1b8ea6cc6def36468e284.svg";
export { ForwardRef as ReactComponent };